import { render, staticRenderFns } from "./ConfirmStockUpComponent.vue?vue&type=template&id=228cb771&scoped=true"
import script from "./ConfirmStockUpComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmStockUpComponent.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmStockUpComponent.vue?vue&type=style&index=0&id=228cb771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228cb771",
  null
  
)

export default component.exports